export default "__VITE_ASSET__Uocom$4R__"